module.exports = {
       // props: ['items'],
        data:function(){
            return {
            }
        },
        ready:function(){
            
        },
        methods:{
           
        },
        components:{
        	tooltip:require('vue-strap').tooltip
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/search.vue
// module id = 45
// module chunks = 0